import React from "react";
import { Bouncer } from "@/components/Bouncer";
import { Progress } from "@/components/ui/progress";

interface PageLoaderProps {
  progress?: { loaded: number; total: number } | null;
}

export const PageLoader = ({ progress }: PageLoaderProps = {}) => {
  const showProgress = progress && progress.total >= 50;
  const percentage = showProgress
    ? Math.round((progress.loaded / progress.total) * 100)
    : 0;

  return (
    <div
      className="align-center flex h-screen w-screen items-center justify-center bg-page-loader"
      role="status"
      data-testid="loading-spinner"
    >
      {showProgress ? (
        <Progress
          value={percentage}
          className="w-80 [&>[data-slot=progress-indicator]]:bg-[image:var(--zeemee-gradient)]"
        />
      ) : (
        <Bouncer />
      )}
      <span className="sr-only">Loading...</span>
    </div>
  );
};
